import React from 'react';

import InfoBlock from '../InfoBlock/InfoBlock';
import MySafety from '../MySafety/MySafety';
import PerfectStay from '../PerfectStay/PerfectStay';
import FormBlock from './FormBlock/FormBlock';
import HeaderPartner from '../Header/Header';
import FooterPartner from '../Footer/Footer';
import JoinUs from '../JoinUs/JoinUs';
import TestimonialBlock from '../TestimonialBlock/Testimonial';

import BusinessNeeds from '../BusinessNeeds/BusinessNeeds';
import WhyMypartner from '../WhyMypartner/WhyMypartner';
import PartnerAdvantage from '../PartnerAdvantage/PartnerAdvantage';

import * as S from './onboarding.styles';

const OnBoarding = ({step, children}) => {
  const deviceWidth = typeof window ==='undefined' ? 100: window.screen.width;
  let blockType = false;
  if(deviceWidth > 1024){
    blockType= true;
  }

  return (
    <S.HomeWrapper id="onboarding">
      <HeaderPartner step={step} userType="onboarding" />
      <S.PageMainWrapper>
        {blockType ?
          <>
            <InfoBlock />
            <FormBlock step={step}>{children}</FormBlock>
          </> :
          <>
            <FormBlock step={step}>{children}</FormBlock>
            <InfoBlock />
          </>
        }
      </S.PageMainWrapper>
      <BusinessNeeds />
      {/* <CashbackBanner /> */}
      <WhyMypartner />
      {/* <InfoStrip /> */}
      {/* <Benefits /> */}
      <PartnerAdvantage />
      <TestimonialBlock />
      {/* <S.Arc /> */}
      <MySafety />
      <PerfectStay />
      <JoinUs />
      <FooterPartner />
    </S.HomeWrapper>
  );
};

export default OnBoarding;
